// extracted by mini-css-extract-plugin
module.exports = {"content-box":"content-box_content-box__1EAsL","title":"content-box_title__3dP_X"};